intra_module.controller('UserAchievementCtrl', function($scope, achievements) {
	$scope.achievements = achievements;
});
